/**
 * Helper to retrieve localized text field from an object.
 * Checks if current language is Marathi ('mr') and returns `obj[field + 'Mr']` or `obj[field + '_mr']`.
 * Fallbacks gracefully if Marathi is missing (to English) or if English is missing (to Marathi).
 */
export const getLangText = (obj, field, lang = 'en') => {
  if (!obj) return '';

  const mainVal = obj[field];
  const mrVal = obj[`${field}Mr`] || obj[`${field}_mr`];

  const hasMr = mrVal && (typeof mrVal === 'string' ? mrVal.trim().length > 0 : Array.isArray(mrVal) && mrVal.length > 0);
  const hasMain = mainVal && (typeof mainVal === 'string' ? mainVal.trim().length > 0 : Array.isArray(mainVal) && mainVal.length > 0);

  if (lang === 'mr') {
    if (hasMr) return mrVal;
    if (hasMain) return mainVal;
    return typeof mainVal === 'string' ? '' : [];
  }

  // English / Default
  if (hasMain) return mainVal;
  if (hasMr) return mrVal;
  return typeof mainVal === 'string' ? '' : [];
};

